import React from 'react'



interface ColorsHeaderProps {
    readonly numberOfOrders?: number
    readonly title: string
    readonly thereAreAnotherOrders?: boolean
}

export function ColorsHeader({ numberOfOrders, title, thereAreAnotherOrders }: ColorsHeaderProps) {
    return (
        <h1 className="color-animation font-bold text-2xl">{numberOfOrders} {title} {`${thereAreAnotherOrders ? "..." : ""}`}</h1>

    )
}
